/**
 * IntelliGems A/B Test: Addon Upsell Popup on ATC
 *
 * Control (A): default add-to-cart behaviour
 * Variant (B): popup on ATC — nothing added until user confirms or skips
 */
(function () {
  'use strict';

  if (window.__addonUpsellABTestInit) return;
  window.__addonUpsellABTestInit = true;

  var BODY_ATTR = 'data-addon-upsell-popup';
  var PORTAL_ATTR = 'data-addon-upsell-portal';
  var busy = false;
  var config = null;
  var resolvedProducts = null;
  var modalEl = null;
  var currentSlide = 0;
  var totalSlides = 1;
  var pendingForm = null;
  var suppressCartOpen = false;
  var upcartObserver = null;
  var suppressInterval = null;
  var modalGuardInterval = null;

  function repairPageVisibility() {
    var body = document.body;
    if (!body) return;

    if (body.style.display === 'none') body.style.display = '';
    if (body.getAttribute('aria-hidden') === 'true') body.removeAttribute('aria-hidden');
  }

  repairPageVisibility();

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('addon_upsell_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    return body && body.getAttribute(BODY_ATTR) === 'true';
  }

  function shouldIntercept() {
    if (!isVariantB()) return false;
    var cfg = getConfig();
    return !!(cfg && cfg.products && cfg.products.length > 0);
  }

  function getConfig() {
    if (config) return config;
    var el = document.getElementById('addon-upsell-config');
    if (!el) return null;
    try {
      config = JSON.parse(el.textContent);
    } catch (e) {
      config = null;
    }
    return config;
  }

  function installCartOpenBlockers() {
    document.addEventListener('product:added', function (event) {
      if (!suppressCartOpen) return;
      event.stopImmediatePropagation();
    }, true);

    document.addEventListener('cart:refresh', function (event) {
      if (!suppressCartOpen) return;
      event.stopImmediatePropagation();
    }, true);
  }

  function injectUpcartHideStyle() {
    if (document.getElementById('addon-upsell-hide-upcart')) return;

    var style = document.createElement('style');
    style.id = 'addon-upsell-hide-upcart';
    style.textContent =
      'html.addon-upsell-open cart-drawer,' +
      'html.addon-upsell-open #CartDrawer,' +
      'html.addon-upsell-open .cart-drawer,' +
      'html.addon-upsell-open upcart-cart-drawer,' +
      'html.addon-upsell-open #upcart,' +
      'html.addon-upsell-open [id^="upcart"],' +
      'html.addon-upsell-open .upcart-cart-drawer,' +
      'html.addon-upsell-open [data-upcart-cart] {' +
      'display: none !important;' +
      'visibility: hidden !important;' +
      'opacity: 0 !important;' +
      'pointer-events: none !important;' +
      '}';
    document.head.appendChild(style);
  }

  function removeUpcartHideStyle() {
    var style = document.getElementById('addon-upsell-hide-upcart');
    if (style) style.remove();

    document
      .querySelectorAll('cart-drawer, #CartDrawer, .cart-drawer, upcart-cart-drawer, #upcart, [id^="upcart"]')
      .forEach(function (el) {
        if (el === document.body) return;
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
      });
  }

  function closeCartDrawers() {
    repairPageVisibility();

    if (document.body) {
      document.body.classList.remove('upcartPopupShow', 'overflow-hidden');
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.close === 'function') cartDrawer.close();
      cartDrawer.classList.remove('active', 'is-empty');
      cartDrawer.removeAttribute('open');
    }

    var nativeClose = document.querySelector(
      'cart-drawer .drawer__close, #CartDrawer .drawer__close, #sidebar-cart [data-action="close-drawer"]'
    );
    if (nativeClose) nativeClose.click();

    var drawer = document.getElementById('sidebar-cart');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');

    var overlay = document.querySelector('.PageOverlay, #CartDrawer-Overlay');
    if (overlay) overlay.classList.remove('is-visible');

    if (window.UpCart) {
      if (typeof window.UpCart.close === 'function') window.UpCart.close();
      if (typeof window.UpCart.closeCart === 'function') window.UpCart.closeCart();
    }

    var upcartDrawer = document.querySelector('upcart-cart-drawer');
    if (upcartDrawer) upcartDrawer.setAttribute('aria-hidden', 'true');
  }

  function installUpcartBlocker() {
    if (!document.body || upcartObserver) return;

    upcartObserver = new MutationObserver(function () {
      if (!suppressCartOpen) return;
      if (document.body.classList.contains('upcartPopupShow')) {
        document.body.classList.remove('upcartPopupShow');
        closeCartDrawers();
      }
    });

    upcartObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function startSuppressingCartOpen() {
    suppressCartOpen = true;
    injectUpcartHideStyle();
    installUpcartBlocker();
    closeCartDrawers();

    clearInterval(suppressInterval);
    var attempts = 0;
    suppressInterval = setInterval(function () {
      closeCartDrawers();
      attempts += 1;
      if (attempts >= 30) {
        clearInterval(suppressInterval);
        suppressInterval = null;
      }
    }, 100);
  }

  function startModalGuard() {
    clearInterval(modalGuardInterval);
    modalGuardInterval = setInterval(closeCartDrawers, 250);
  }

  function stopModalGuard() {
    clearInterval(modalGuardInterval);
    modalGuardInterval = null;
  }

  function stopSuppressingCartOpen() {
    suppressCartOpen = false;
    clearInterval(suppressInterval);
    suppressInterval = null;
    stopModalGuard();
    removeUpcartHideStyle();
  }

  function portalToBody() {
    document.querySelectorAll('[' + PORTAL_ATTR + ']').forEach(function (el) {
      if (el.parentNode && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  function getModal() {
    var cfg = getConfig();
    if (!cfg || !cfg.modalId) return null;
    if (!modalEl || !document.body.contains(modalEl)) {
      modalEl = document.getElementById(cfg.modalId);
    }
    return modalEl;
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;

    startSuppressingCartOpen();
    startModalGuard();
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('addon-upsell-open');
    closeCartDrawers();
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    document.documentElement.classList.add('addon-upsell--instant');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('addon-upsell-open');
    stopSuppressingCartOpen();

    requestAnimationFrame(function () {
      document.documentElement.classList.remove('addon-upsell--instant');
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function mapShopifyProduct(product) {
    if (!product || !product.variants || !product.variants.length) return null;

    var variant = null;
    var i;
    for (i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) return null;

    var image = product.featured_image;
    if (typeof image === 'object' && image && image.src) image = image.src;

    return {
      id: product.id,
      title: product.title,
      handle: product.handle,
      url: product.url || '/products/' + product.handle,
      featured_image: image || null,
      price: variant.price,
      price_formatted: formatMoneyFromCents(variant.price),
      compare_at_price: variant.compare_at_price || 0,
      compare_at_price_formatted: formatMoneyFromCents(variant.compare_at_price || 0),
      variant_id: variant.id,
      available: true
    };
  }

  function isBlockedAddonProduct(product) {
    if (!product) return true;
    var haystack = (
      String(product.title || '') +
      ' ' +
      String(product.handle || '')
    ).toLowerCase();
    if (haystack.indexOf('insurance') !== -1) return true;
    if (haystack.indexOf('insured') !== -1) return true;
    if (haystack.indexOf('insured-shipping') !== -1) return true;
    if (haystack.indexOf('only-shipping') !== -1) return true;
    if (haystack.indexOf('shipping insurance') !== -1) return true;
    if (haystack.indexOf('damage, loss') !== -1) return true;
    if (haystack.indexOf('theft') !== -1 && haystack.indexOf('ship') !== -1) {
      return true;
    }
    return false;
  }

  function isAccessoryProduct(product) {
    if (!product || isBlockedAddonProduct(product)) return false;
    var haystack = (
      String(product.title || '') +
      ' ' +
      String(product.handle || '')
    ).toLowerCase();
    var accessoryHints = [
      'sock',
      'insole',
      'sole',
      'lace',
      'shoelace',
      'cream',
      'pad',
      'orthopedic soles',
    ];
    var i;
    for (i = 0; i < accessoryHints.length; i++) {
      if (haystack.indexOf(accessoryHints[i]) !== -1) return true;
    }
    return false;
  }

  function fetchRecommendationProducts(productId, intent) {
    return fetch(
      '/recommendations/products.json?product_id=' +
        productId +
        '&limit=12&intent=' +
        intent,
      {
        credentials: 'same-origin',
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return (data.products || [])
          .map(mapShopifyProduct)
          .filter(function (product) {
            return product && isAccessoryProduct(product);
          });
      })
      .catch(function () {
        return [];
      });
  }

  function loadProducts() {
    if (resolvedProducts) return Promise.resolve(resolvedProducts);

    var cfg = getConfig();
    if (!cfg) {
      resolvedProducts = [];
      return Promise.resolve(resolvedProducts);
    }

    var base = (cfg.products || []).filter(function (product) {
      return (
        product.available &&
        product.variant_id &&
        product.id !== cfg.productId &&
        !isBlockedAddonProduct(product)
      );
    });

    if (base.length >= 4) {
      resolvedProducts = base.slice(0, 4);
      return Promise.resolve(resolvedProducts);
    }

    return fetchRecommendationProducts(cfg.productId, 'related')
      .then(function (recs) {
        var seen = {};
        base.forEach(function (p) {
          seen[p.id] = true;
        });
        recs.forEach(function (p) {
          if (base.length >= 4) return;
          if (!p || seen[p.id] || p.id === cfg.productId) return;
          if (isBlockedAddonProduct(p)) return;
          seen[p.id] = true;
          base.push(p);
        });
        resolvedProducts = base.slice(0, 4);
        return resolvedProducts;
      })
      .catch(function () {
        resolvedProducts = base.slice(0, 4);
        return resolvedProducts;
      });
  }

  function isMobileLayout() {
    return window.innerWidth <= 749;
  }

  function buildSlides(products) {
    if (isMobileLayout()) {
      return products.map(function (p) {
        return [p];
      });
    }
    var slides = [];
    var i;
    for (i = 0; i < products.length; i += 2) {
      slides.push(products.slice(i, i + 2));
    }
    return slides;
  }

  function makeCardBtnLabel(product) {
    var salePrice = formatMoneyFromCents(product.price);
    var comparePrice = formatMoneyFromCents(product.compare_at_price || 0);
    var priceHtml =
      product.compare_at_price > product.price
        ? '<s class="addon-upsell__card-compare">' +
          escapeHtml(comparePrice) +
          '</s> <span class="addon-upsell__card-current">' +
          escapeHtml(salePrice) +
          '</span>'
        : '<span class="addon-upsell__card-current">' + escapeHtml(salePrice) + '</span>';
    return 'ADD TO CART — ' + priceHtml;
  }

  function makeCardHtml(product) {
    var imageInner = product.featured_image
      ? '<img src="' +
        product.featured_image +
        '" alt="' +
        escapeHtml(product.title) +
        '" loading="eager" decoding="async">'
      : '<div class="addon-upsell__card-image--placeholder"></div>';

    return (
      '<div class="addon-upsell__card-image">' +
      imageInner +
      '</div>' +
      '<div class="addon-upsell__card-title">' +
      escapeHtml(product.title) +
      '</div>' +
      '<button type="button" class="addon-upsell__card-btn" data-addon-upsell-atc data-variant-id="' +
      String(product.variant_id) +
      '">' +
      makeCardBtnLabel(product) +
      '</button>'
    );
  }

  function showSlide(index) {
    var modal = getModal();
    var container = modal && modal.querySelector('[data-addon-upsell-products]');
    if (!modal || !container || totalSlides < 1) return;

    currentSlide = ((index % totalSlides) + totalSlides) % totalSlides;
    var offset = -currentSlide * (100 / totalSlides);
    container.style.transform = 'translateX(' + offset + '%)';

    modal.querySelectorAll('[data-addon-upsell-dot]').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === currentSlide);
    });

    var prev = modal.querySelector('[data-addon-upsell-prev]');
    var next = modal.querySelector('[data-addon-upsell-next]');
    if (prev) prev.disabled = totalSlides <= 1;
    if (next) next.disabled = totalSlides <= 1;
  }

  function buildDots(count) {
    var modal = getModal();
    if (!modal) return;
    var dots = modal.querySelector('[data-addon-upsell-dots]');
    var slider = modal.querySelector('[data-addon-upsell-slider]');
    if (!dots) return;

    dots.innerHTML = '';
    if (count <= 1) {
      dots.hidden = true;
      if (slider) slider.classList.add('is-single');
      return;
    }

    dots.hidden = false;
    if (slider) slider.classList.remove('is-single');

    var i;
    for (i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'addon-upsell__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-addon-upsell-dot', String(i));
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dots.appendChild(dot);
    }
  }

  function renderProducts(products) {
    var cfg = getConfig();
    var modal = getModal();
    if (!cfg || !modal) return;

    var container = modal.querySelector('[data-addon-upsell-products]');
    if (!container) return;

    container.innerHTML = '';
    container.style.width = '';
    container.style.transform = '';
    currentSlide = 0;
    totalSlides = 1;

    if (!products.length) {
      container.innerHTML = '<p class="addon-upsell__empty">No addon products available.</p>';
      buildDots(0);
      return;
    }

    var slides = buildSlides(products);
    totalSlides = slides.length || 1;
    container.style.width = totalSlides * 100 + '%';

    var slideWidthPct = 100 / totalSlides;
    slides.forEach(function (pair) {
      var slideEl = document.createElement('div');
      slideEl.className = 'addon-upsell__slide';
      slideEl.style.flexBasis = slideWidthPct + '%';
      slideEl.style.maxWidth = slideWidthPct + '%';
      pair.forEach(function (product) {
        var card = document.createElement('div');
        card.className = 'addon-upsell__card';
        card.innerHTML = makeCardHtml(product);
        slideEl.appendChild(card);
      });
      container.appendChild(slideEl);
    });

    buildDots(totalSlides);
    showSlide(0);
  }

  function buildCartItems(form, addonVariantId) {
    var formData = serializeForm(form);
    var items = [];
    var mainItem = {
      id: parseInt(formData.id, 10),
      quantity: parseInt(formData.quantity || 1, 10),
    };
    var properties = {};
    var key;
    var match;

    for (key in formData) {
      if (!Object.prototype.hasOwnProperty.call(formData, key)) continue;
      match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = formData[key];
    }

    if (Object.keys(properties).length) {
      mainItem.properties = properties;
    }

    items.push(mainItem);

    if (addonVariantId) {
      items.push({ id: parseInt(addonVariantId, 10), quantity: 1 });
    }

    return items;
  }

  function getCartSectionIds() {
    var ids = ['cart-drawer'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var section = bubble.closest('[id^="shopify-section-"]');
      if (section && section.id) {
        ids.push(section.id.replace('shopify-section-', ''));
      } else {
        ids.push('cart-icon-bubble');
      }
    }
    return ids.join(',');
  }

  function addItemsToCart(form, addonVariantId) {
    var addUrl =
      (window.routes && (window.routes.cart_add_url || window.routes.cartAddUrl)) ||
      '/cart/add';
    var sections = getCartSectionIds();

    return fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: buildCartItems(form, addonVariantId),
        sections: sections,
        sections_url: window.location.pathname,
      }),
    }).then(function (response) {
      return response.json().then(function (content) {
        if (!response.ok) {
          throw new Error(
            (content && (content.description || content.message)) ||
              'Could not add to cart'
          );
        }
        return content;
      });
    });
  }

  function serializeForm(form) {
    var data = {};
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      data[key] = value;
    });
    return data;
  }

  function showFormError(form, message) {
    var button =
      form.querySelector('.product-form__submit, .atc-button, .ProductForm__AddToCart') ||
      form.querySelector('[type="submit"]');
    if (!button) return;

    var existing = form.querySelector('.ProductForm__Error');
    if (existing) existing.remove();

    var errorEl = document.createElement('span');
    errorEl.className = 'ProductForm__Error Alert Alert--error';
    errorEl.style.display = 'block';
    errorEl.style.marginTop = '0.5rem';
    errorEl.style.color = '#EB001B';
    errorEl.textContent = message;
    button.insertAdjacentElement('afterend', errorEl);
    setTimeout(function () {
      errorEl.remove();
    }, 3000);
  }

  function updateHeaderCartCount(itemCount) {
    document
      .querySelectorAll(
        '.Header__CartCount, .cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble .cart-count-bubble span, #cart-icon-bubble span[aria-hidden]'
      )
      .forEach(function (el) {
        el.textContent = itemCount;
      });

    document.querySelectorAll('.Header__CartDot, .cart-count-bubble').forEach(function (dot) {
      if (itemCount > 0) {
        dot.classList.add('is-visible');
        dot.classList.remove('hidden');
        if (dot.hasAttribute('hidden')) dot.removeAttribute('hidden');
      } else {
        dot.classList.remove('is-visible');
      }
    });
  }

  function applySectionHtml(sectionId, html) {
    if (!html) return;
    var selector = '#shopify-section-' + sectionId;
    var current = document.querySelector(selector);
    if (current) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var next = temp.querySelector(selector) || temp.firstElementChild;
      if (next) current.innerHTML = next.innerHTML;
      return;
    }

    if (sectionId === 'cart-drawer') {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var inner =
        wrap.querySelector('cart-drawer') ||
        wrap.querySelector('#CartDrawer') ||
        wrap.querySelector('.cart-drawer');
      if (inner && inner.tagName && inner.tagName.toLowerCase() === 'cart-drawer') {
        drawer.innerHTML = inner.innerHTML;
        drawer.className = inner.className;
      } else if (inner) {
        drawer.innerHTML = inner.outerHTML;
      }
    }
  }

  function refreshCartUI(parsedState) {
    var cartDrawer = document.querySelector('cart-drawer');

    if (
      parsedState &&
      parsedState.sections &&
      cartDrawer &&
      typeof cartDrawer.renderContents === 'function'
    ) {
      try {
        cartDrawer.renderContents(parsedState);
        return Promise.resolve(parsedState);
      } catch (e) {
        /* fall through */
      }
    }

    if (parsedState && parsedState.sections) {
      Object.keys(parsedState.sections).forEach(function (id) {
        applySectionHtml(id, parsedState.sections[id]);
      });
    }

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count || 0);

        return fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (sections) {
            if (sections && sections['cart-drawer']) {
              applySectionHtml('cart-drawer', sections['cart-drawer']);
            }
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
            return cart;
          })
          .catch(function () {
            return cart;
          });
      });
  }

  function openNativeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return true;
      }
      cartDrawer.classList.add('active');
      return true;
    }

    var bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      bubble.click();
      return true;
    }
    return false;
  }

  function openCartAfterAdd(parsedState) {
    stopSuppressingCartOpen();
    return refreshCartUI(parsedState).then(function (cart) {
      if (cart && typeof cart.item_count === 'number') {
        updateHeaderCartCount(cart.item_count);
      }
      // Let section HTML settle, then open.
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          openNativeCartDrawer();
          if (window.UpCart) {
            if (typeof window.UpCart.refresh === 'function') window.UpCart.refresh();
            if (typeof window.UpCart.open === 'function') window.UpCart.open();
          }
          resolve(cart);
        });
      });
    });
  }

  function formatMoneyFromCents(cents) {
    var cfg = getConfig();
    var format =
      (cfg && cfg.moneyFormat) ||
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function onCardAddToCart(btn) {
    if (busy || !pendingForm || !btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    busy = true;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var form = pendingForm;
    pendingForm = null;
    closeModal();

    addItemsToCart(form, variantId)
      .then(function (parsedState) {
        return openCartAfterAdd(parsedState);
      })
      .catch(function (err) {
        console.error('[addon-upsell]', err);
        showFormError(form, err.message || 'Could not add to cart');
      })
      .finally(function () {
        busy = false;
      });
  }

  function onSkipClick() {
    if (busy) return;

    if (!pendingForm) {
      closeModal();
      return;
    }

    busy = true;
    var form = pendingForm;
    pendingForm = null;
    closeModal();

    addItemsToCart(form, null)
      .then(function (parsedState) {
        return openCartAfterAdd(parsedState);
      })
      .catch(function (err) {
        console.error('[addon-upsell]', err);
        showFormError(form, err.message || 'Could not add to cart');
      })
      .finally(function () {
        busy = false;
      });
  }

  function handleVariantBSubmit(form) {
    if (busy) return;
    if (!getConfig()) return;

    pendingForm = form;
    resolvedProducts = null;
    startSuppressingCartOpen();

    portalToBody();

    loadProducts()
      .then(function (products) {
        if (!products.length) {
          stopSuppressingCartOpen();
          var formToSubmit = pendingForm;
          pendingForm = null;
          if (formToSubmit) {
            if (typeof formToSubmit.requestSubmit === 'function') {
              formToSubmit.requestSubmit();
            } else {
              formToSubmit.submit();
            }
          }
          return;
        }
        renderProducts(products);
        openModal();
      })
      .catch(function (err) {
        stopSuppressingCartOpen();
        pendingForm = null;
        showFormError(form, err.message);
      });
  }

  function findProductForm(el) {
    if (!el) return null;
    return (
      el.closest('form[action*="/cart/add"]') ||
      el.closest('form.ProductForm') ||
      (el.closest('product-form') && el.closest('product-form').querySelector('form'))
    );
  }

  function onFormSubmit(event) {
    if (!shouldIntercept()) return;
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) {
      if (!form.classList.contains('ProductForm')) return;
    }
    if (!form.closest('product-form, .product-form, .main-product-form')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    handleVariantBSubmit(form);
  }

  function onAddToCartClick(event) {
    if (!shouldIntercept()) return;
    var button = event.target.closest(
      '[data-action="add-to-cart"], .product-form__submit, .atc-button, .main-product-atc'
    );
    if (!button) return;
    var form = findProductForm(button);
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    handleVariantBSubmit(form);
  }

  function attachModalListeners() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-addon-upsell-close]')) {
        event.preventDefault();
        onSkipClick();
        return;
      }

      var atcBtn = event.target.closest('[data-addon-upsell-atc]');
      if (atcBtn) {
        event.preventDefault();
        onCardAddToCart(atcBtn);
        return;
      }

      var prev = event.target.closest('[data-addon-upsell-prev]');
      var next = event.target.closest('[data-addon-upsell-next]');
      var dot = event.target.closest('[data-addon-upsell-dot]');
      if (!prev && !next && !dot) return;

      event.preventDefault();
      if (prev) {
        showSlide(currentSlide - 1);
        return;
      }
      if (next) {
        showSlide(currentSlide + 1);
        return;
      }
      if (dot) {
        var index = parseInt(dot.getAttribute('data-addon-upsell-dot'), 10) || 0;
        showSlide(index);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var modal = getModal();
      if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;
      onSkipClick();
    });

    window.addEventListener('resize', function () {
      var modal = getModal();
      if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;
      if (!resolvedProducts || !resolvedProducts.length) return;
      renderProducts(resolvedProducts);
    });
  }

  function init() {
    repairPageVisibility();
    installCartOpenBlockers();
    installUpcartBlocker();
    portalToBody();
    attachModalListeners();
    document.addEventListener('submit', onFormSubmit, true);
    document.addEventListener('click', onAddToCartClick, true);
    document.addEventListener('shopify:section:load', portalToBody);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
